import React, { useState, useEffect, useRef } from "react";
import styles from "./NewsSection.module.sass";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const NewsSection = ({ isFullWidth, isHomepage, isListingPage }) => {
  const sourceRef = useRef(null);   // jahan se height leni hai
  const targetRef = useRef(null);   // jahan height apply karni hai

  const headingRef = useRef(null);  // h3
  const metaRef = useRef(null);     // category/date div
  const descRef = useRef(null);     // description p
  const imageRef = useRef(null);    // image to resize

  const [latestNews, setLatestNews] = useState([]);
  const [latestNewsSingle, setLatestNewsSingle] = useState({});
  const [width, setwidth] = useState(window.innerWidth);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_SERVER_URL}/latest-news`)
      .then(({ data }) => {
        setLatestNews(data?.data || []);
        setLatestNewsSingle(data?.latestNewsSingle || {});
      })
      .catch((err) => console.error("Error fetching news:", err));

    const handleResize = () => setwidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sync featured box height
  useEffect(() => {
    const updateHeight = () => {
      if (sourceRef.current && targetRef.current) {
        const height = sourceRef.current.offsetHeight;
        targetRef.current.style.height = `${height}px`;
      }
    };

    window.addEventListener("resize", updateHeight);
    updateHeight(); // initial call

    return () => window.removeEventListener("resize", updateHeight);
  }, [latestNews, latestNewsSingle]);

  // Dynamically set image height based on remaining space
  useEffect(() => {
    const updateImageHeight = () => {
      if (
        targetRef.current &&
        headingRef.current &&
        metaRef.current &&
        descRef.current &&
        imageRef.current
      ) {
        const totalHeight = targetRef.current.offsetHeight;
        const headingHeight = headingRef.current.offsetHeight;
        const metaHeight = metaRef.current.offsetHeight;
        const descHeight = descRef.current.offsetHeight;

        const buffer = 20; // optional margin
        const imgHeight = totalHeight - headingHeight - metaHeight - descHeight - buffer;

        if (imgHeight > 0) {
          imageRef.current.style.height = `${imgHeight}px`;
          imageRef.current.style.objectFit = "cover";
        }
      }
    };

    updateImageHeight();
    window.addEventListener("resize", updateImageHeight);
    return () => window.removeEventListener("resize", updateImageHeight);
  }, [latestNewsSingle]);

  const handleNavigation = (path, params = {}) => {
    navigate(path, { state: params });
  };

  const truncateText = (text, limit) => {
    const strippedText = text.replace(/(<([^>]+)>)/gi, "");
    return strippedText.length > limit
      ? `${strippedText.substring(0, limit)}`
      : strippedText;
  };

  return (
    <div className={styles.wholeContainer}>
      <div
        className={
          isFullWidth === true
            ? styles.latestNewsLightContainer
            : styles.latestNewsContainer
        }
      >
        {isHomepage || width < 1023 ? <h2>Latest News</h2> : null}
        <div className={styles.latestNews}>
          <div className={styles.newsList} ref={sourceRef}>
            {!isHomepage && width >= 1023 ? <h2>Latest News</h2> : null}
            <ul>
              {latestNews?.map((item) => (
                <li
                  key={item.id}
                  onClick={() => handleNavigation(`/news/${item.url || ""}`)}
                  className={styles.newsItem}
                >
                  <div className={styles.categoryAndDate}>
                    {isFullWidth === true ? null : (
                      <p>{item.category?.name || ""}</p>
                    )}
                    <p>{item.publishdate || ""}</p>
                  </div>
                  <div className={styles.newsTitle}>
                    {truncateText(item?.title || "", 75)}
                  </div>
                </li>
              ))}
            </ul>

            {isFullWidth === false && isHomepage === true ? (
              <button
                className={styles.showAllNews}
                onClick={() => handleNavigation(`/news`)}
              >
                Show All News
                <svg
                  className={styles.iconArrow}
                  width="24"
                  height="16"
                  viewBox="0 0 24 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.2071 8.70711C23.5976 8.31658 23.5976 7.68342 23.2071 7.29289L16.8431 0.928932C16.4526 0.538408 15.8195 0.538408 15.4289 0.928932C15.0384 1.31946 15.0384 1.95262 15.4289 2.34315L21.0858 8L15.4289 13.6569C15.0384 14.0474 15.0384 14.6805 15.4289 15.0711C15.8195 15.4616 16.4526 15.4616 16.8431 15.0711L23.2071 8.70711ZM0 9H22.5V7H0V9Z"
                    style={{ fill: "#FFF" }}
                  />
                </svg>
              </button>
            ) : null}
          </div>

          {isFullWidth === false && latestNewsSingle ? (
            <div
              ref={targetRef}
              className={styles.featuredNews}
              onClick={() =>
                handleNavigation(`/news/${latestNewsSingle.url || ""}`)
              }
              style={isListingPage ? { marginTop: "10px" } : null}
            >
              <h3 ref={headingRef}>
                {truncateText(latestNewsSingle?.title || "", 75)}
              </h3>

              <img
                ref={imageRef}
                src={`${process.env.REACT_APP_API_SERVER_URL}/${latestNewsSingle?.image || ""}`}
                alt={latestNewsSingle?.title || ""}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/dummy.jpg";
                }}
                style={isHomepage ? null : { marginTop: "14px", paddingTop: "5px" }}
              />

              <div ref={metaRef} className={styles.featuredcategoryAndDate}>
                <p>{latestNewsSingle?.category?.name || ""}</p>
                <p>{latestNewsSingle?.publishdate || ""}</p>
              </div>

              <p
                ref={descRef}
                dangerouslySetInnerHTML={{
                  __html: truncateText(
                    latestNewsSingle?.shortdescription || "",
                    180
                  ),
                }}
              ></p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
